import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/site-admin/overview")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/site-admin/overview"!</div>;
}
